/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import { MdLogout } from "react-icons/md";
import routes from "routes";
import { clearAuth } from "api";
import LogoIcon from "components/brand/LogoIcon";

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;

  const handleLogout = () => {
    clearAuth();
    window.location.href = "/auth/sign-in";
  };

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className="mx-[28px] mt-[36px] flex items-center gap-2">
        <LogoIcon size={36} />
        <div className="font-outfit text-[20px] font-extrabold tracking-tight text-brand-500 dark:text-white">
          MALİ AJANDA
        </div>
      </div>
      <p className="mx-[28px] mt-1 text-[10px] uppercase tracking-[0.2em] text-gray-500 dark:text-white/60">Admin Panel</p>
      <div className="mt-[40px] mb-5 h-px bg-gray-300 dark:bg-white/30" />

      <ul className="mb-auto pt-1">
        <Links routes={routes} />
      </ul>

      {/* Logout Button */}
      <div className="flex justify-center px-8">
        <button
          onClick={handleLogout}
          className="flex w-full items-center justify-center gap-2 rounded-xl bg-red-50 py-3 text-sm font-medium text-red-600 hover:bg-red-100 transition dark:bg-red-900/20 dark:text-red-400"
        >
          <MdLogout className="h-5 w-5" />
          Cikis Yap
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
